import { render } from "./FauxPaper.vue?vue&type=template&id=290706e5&scoped=true"
import script from "./FauxPaper.vue?vue&type=script&lang=js"
export * from "./FauxPaper.vue?vue&type=script&lang=js"

import "./FauxPaper.vue?vue&type=style&index=0&id=290706e5&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-290706e5"]])

export default __exports__